module.exports = __webpack_public_path__ + "img/next-steps.c78f7802.webp";